import { ENV_CONFIG } from 'config/environment';

const privacyPolicyUrl = `${
  ENV_CONFIG().CLOUD_STORAGE.URL
}/legal/Oath%20Privacy%20Policy%20as%20of%209.7.2026.pdf`;

const termsOfUseUrl = `${
  ENV_CONFIG().CLOUD_STORAGE.URL
}/legal/Oath%20Terms%20of%20Use%209.17.2026.pdf`;

export const footerLinkSections = [
  {
    title: 'ABOUT OATH',
    links: [
      { label: 'Who We Are', url: '/donor' },
      { label: 'Our Algorithm', url: '/impact_score' },
      { label: 'In the Media', url: '/gallery' },
    ],
  },
  {
    title: 'DONATE',
    links: [
      { label: 'Top Issues', url: '/set?p=top-issues' },
      { label: 'Search Candidates', url: '/cart' },
      { label: 'Donate Monthly', url: '/autopilot' },
    ],
  },
  {
    title: 'SUPPORT',
    links: [
      { label: 'Contact Us', url: '/contact' },
      { label: 'Help Center', url: 'https://helpcenter.oath.vote/oath-help-center' },
      { label: 'Privacy Policy', url: privacyPolicyUrl },
      { label: 'Terms of Use', url: termsOfUseUrl },
    ],
  },
];
